import { getContentTypeRouteSlug } from "./utils";

// Shared links always point at production, never at whichever origin the app
// happens to be served from. www is the canonical origin (the apex 308s to it),
// so shared links match the canonical tags and sitemap without a redirect hop.
export const SHARE_ORIGIN = "https://www.curateapp.io";

// Long titles (mainly books) still need to fit a readable URL.
const MAX_SLUG_LENGTH = 80;

// Mirrors the backend's slugify (flask-server/app/services/meta.py), which builds
// the canonical and sitemap URLs — the two must never disagree, or the canonical
// would point at a URL this app immediately rewrites. Apostrophes are dropped
// rather than dashed ("NYT's" → "nyts", not "nyt-s").
export function slugify(text) {
  if (!text) return "";
  let slug = text
    .toLowerCase()
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  if (slug.length > MAX_SLUG_LENGTH) {
    slug = slug.slice(0, MAX_SLUG_LENGTH).replace(/-+$/g, "");
  }
  return slug;
}

// Builds /movie|tv|book/:contentId/:slug. `title` is optional — when absent
// (e.g. navigating on a server-resolved id with no title in hand yet) the path
// is returned without a slug, and the detail route corrects it once metadata loads.
export function buildContentPath({ contentType, contentId, title }) {
  const routeSlug = getContentTypeRouteSlug(contentType);
  const slug = title ? slugify(title) : "";
  return slug
    ? `/${routeSlug}/${contentId}/${slug}`
    : `/${routeSlug}/${contentId}`;
}

// Builds /list/:listId/:slug.
export function buildListPath(list) {
  const slug = list?.title ? slugify(list.title) : "";
  return slug ? `/list/${list.list_id}/${slug}` : `/list/${list.list_id}`;
}
